module.exports = __webpack_public_path__ + "static/media/sword.2c0dc38d.svg";